import { LoadingContainer } from 'components/loadingContainer'
import { useAllAvailableEventLocations } from 'hooks/user/useEvents/useEventLocationsInUse'
import { LocationType } from 'types/Location'

import { FilterButton, FilterContainer } from './locationFilter.style'

interface LocationFilterProps {
    selectedDate: Date
    selectedLocation: string | null
    setSelectedLocation: (locationId: string | null) => void
    availableLocations: string[]
}

export const LocationFilter = ({ selectedDate, selectedLocation, setSelectedLocation, availableLocations }: LocationFilterProps) => {
    const { data: locationData, isLoading, error } = useAllAvailableEventLocations()

    return (
        <FilterContainer>
            <LoadingContainer isLoading={isLoading} error={error}>
                {locationData && (
                    <div>
                        <FilterButton className={selectedLocation === null ? 'active' : ''} onClick={() => setSelectedLocation(null)}>
                            Minden helyszín
                        </FilterButton>
                        {locationData
                            .filter((location: LocationType) => availableLocations.includes(location.location_id))
                            .map((location: LocationType) => (
                                <FilterButton
                                    key={location.location_id}
                                    className={selectedLocation === location.location_id ? 'active' : ''}
                                    onClick={() => setSelectedLocation(location.location_id)}
                                >
                                    {location.name}
                                </FilterButton>
                            ))}
                    </div>
                )}
            </LoadingContainer>
        </FilterContainer>
    )
}
